<template>
	<div>
		<v-data-table
			:headers="headers"
			:items="filteredInventoryConsumables"
			:search="appBarSearch"
			:loading="loading"
			:height="pageHeight(176)"
			dense
			:no-data-text="$t('no-data-available')"
			:loading-text="$t('loading')"
			:items-per-page="-1"
			sort-by="name">
			<template #item="{ item, index }">
				<tr class="text-left" :class="{ 'odd-row': index % 2 }">
					<td :style="{ color: item.organization?.institutionName ? 'black' : 'red' }">
						{{ item.organization?.institutionName ?? $t('unassigned') }}
					</td>
					<td :style="{ color: item.location?.hospitalName ? 'black' : 'red' }">
						{{ item.location?.hospitalName ?? $t('unassigned') }}
					</td>
					<td>{{ item?.consumableModel?.manufacturer || '-' }}</td>
					<td>{{ item.supplierName || '-' }}</td>
					<td>{{ item.sellQuantity }}</td>
					<td>{{ item.sellPricePerUnit }} {{ item.sellCurrency }}</td>
					<td>{{ item.shipmentCost }} {{ item.shipmentCurrency }}</td>
					<td>{{ item.shipmentDate ? formatTimestamp(item.shipmentDate) : '-' }}</td>
					<td>{{ item.status }}</td>
					<td class="text-right" style="min-width: 111px">
						<v-icon color="primary" @click="openDetailsDialog(item)">mdi-eye</v-icon>
						<v-icon color="primary" @click="assignConsumable(item)">mdi-pencil</v-icon>
						<v-icon color="primary" @click="enableDeleteDialog(item)">mdi-delete</v-icon>
					</td>
				</tr>
			</template>
		</v-data-table>
		<ConsumableViewDialog
			v-if="selectedConsumable"
			:selectedConsumable="selectedConsumable"
			:showDialog.sync="showDetailsDialog"
			@closeDialog="showDetailsDialog = false" />
		<DeleteDialog
			:dialog.sync="showDeleteDialog"
			@confirm="
				showDeleteDialog = false;
				deleteUserConfirm();
			" />
	</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { formatTimestamp } from '../../../utils/utilities';
import ConsumableViewDialog from '../../dialogs/ConsumableViewDialog.vue';
import DeleteDialog from '@/views/dialogs/DeleteDialog.vue';

export default {
	name: 'InventoryConsumable',
	components: { ConsumableViewDialog, DeleteDialog },
	data () {
		return {
			inventoryConsumables: [],
			loading: false,
			headers: [
				{ text: this.$t('organization-name'), value: 'organization.institutionName' },
				{ text: this.$t('hospital-name'), value: 'location.hospitalName' },
				{ text: this.$t('manufacturer'), value: 'manufacturer' },
				{ text: this.$t('supplier-name'), value: 'supplierName' },
				{ text: this.$t('sell-quantity'), value: 'sellQuantity' },
				{ text: this.$t('sell-price-per-unit'), value: 'sellPricePerUnit' },
				{ text: this.$t('shipment-cost'), value: 'shipmentCost' },
				{ text: this.$t('shipment-date'), value: 'shipmentDate' },
				{ text: this.$t('status'), value: 'status' },
				{ text: this.$t('actions'), value: 'actions', align: 'end' },
			],
			showDetailsDialog: false,
			selectedConsumable: null,
			itemToDelete: null,
			showDeleteDialog: false,
		};
	},
	methods: {
		...mapActions({
			getConsumables: 'inventoryConsumables/getConsumables',
			getConsumableById: 'inventoryConsumables/getConsumableById',
			deleteConsumableItem: 'inventoryConsumables/deleteConsumable',
			getConsumableCatalogById: 'inventoryConsumableCatalogs/getConsumableCatalogById',
		}),
		formatTimestamp,
		enableDeleteDialog (item) {
			this.itemToDelete = item;
			this.showDeleteDialog = true;
		},
		async getConsumableItems () {
			this.inventoryConsumables = await this.getConsumables();
		},
		async assignConsumable (item) {
			await this.$store.commit('inventoryConsumables/SET_CONSUMABLE', item);
			await this.getConsumableById(item.id);
			await this.$store.commit('SET_UPDATE_DETAILS_DRAWER', {
				updateDrawer: true,
				page2: 'assign consumable catalog',
			});
		},
		openDetailsDialog (item) {
			this.selectedConsumable = item;
			this.showDetailsDialog = true;
		},
		async deleteUserConfirm () {
			const result = await this.deleteConsumableItem(this.itemToDelete.id);
			if (result.resFlag) {
				this.showDeleteDialog = false;
				this.getConsumableItems();
			}
		},
	},
	computed: {
		...mapGetters({
			pageHeight: 'pageHeight',
			appBarSearch: 'filterbar/getSearch',
			appBarMedicalInstitution: 'filterbar/getMedicalInstitution',
			selectedHospitalId: 'filterbar/getHospitalId',
		}),
		...mapState({
			detailsDrawer: (state) => state.detailsDrawer,
			updateDrawer: (state) => state.updateDrawer,
		}),
		filteredInventoryConsumables () {
			return this.inventoryConsumables
				.filter((item) => item.organizationId === this.appBarMedicalInstitution || !this.appBarMedicalInstitution)
				.filter(
					(item) =>
						item.locationId === this.selectedHospitalId ||
						this.selectedHospitalId === null ||
						this.selectedHospitalId === -99,
				);
		},
	},
	async mounted () {
		this.getConsumableItems();
	},
	watch: {
		detailsDrawer (val) {
			if (!val) {
				this.getConsumableItems();
			}
		},
		updateDrawer (val) {
			if (!val) {
				this.getConsumableItems();
			}
		},
	},
};
</script>
